import React, { useState } from "react"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import CloseIcon from "@material-ui/icons/Close"

import styles from "./index.module.scss"
import UserAvatar from "../elements/UserAvatar"
import { getMessageTime } from "../../helpers/dateHandlers"
import defaultAvatar from "../../images/defaultUserAvatar.png"

const PeerCircleMembersModal = ({ isOpen, onClose, question, members }) => {
  const [commentText, setCommentText] = useState("")

  if (!isOpen) return null

  const getInitials = (name) => {
    if (!name) return ""
    const parts = name.trim().split(" ")
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    }
    return name.substring(0, 2).toUpperCase()
  }

  const handlePostComment = () => {
    if (commentText.trim()) {
      // TODO: Implement comment posting
      setCommentText("")
    }
  }

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div className={styles.headerInfo}>
            <UserAvatar
              src={question?.user?.photo}
              alt={question?.user?.name || question?.user?.full_name}
              size={55}
            />
            <div className={styles.headerText}>
              <div className={styles.postedBy}>
                Posted by{" "}
                <Link
                  to={`/${question?.user?.type?.toLowerCase()}/${question?.user?.uuid}`}
                  className={styles.authorLink}
                >
                  {question?.user?.name || question?.user?.full_name}
                </Link>
              </div>
              <div className={styles.postedDate}>
                {getMessageTime(question?.created_at)}
              </div>
            </div>
          </div>
          <button className={styles.closeButton} onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <div className={styles.modalTitle}>{question?.title}</div>

        <div className={styles.modalBody}>
          <div className={styles.membersList}>
            {members && members.length > 0 && (
              <div className={styles.memberItem}>
                <div className={styles.memberAvatar}>
                  {members[0]?.photo ? (
                    <img
                      src={members[0].photo}
                      alt={members[0].name}
                      className={styles.avatarImage}
                    />
                  ) : (
                    <div className={styles.avatarInitials}>
                      {getInitials(members[0]?.name || members[0]?.full_name)}
                    </div>
                  )}
                </div>
                <Link
                  to={`/${members[0]?.type?.toLowerCase()}/${members[0]?.uuid}`}
                  className={styles.memberName}
                >
                  {members[0]?.name || members[0]?.full_name}
                </Link>
              </div>
            )}
            {members &&
              members.slice(1).map((member, index) => (
                <div key={member.uuid || index} className={styles.memberItem}>
                  <div className={styles.memberAvatar}>
                    {member.photo ? (
                      <img
                        src={member.photo}
                        alt={member.name}
                        className={styles.avatarImage}
                      />
                    ) : (
                      <div className={styles.avatarInitials}>
                        {getInitials(member?.name || member?.full_name)}
                      </div>
                    )}
                  </div>
                  <Link
                    to={`/${member?.type?.toLowerCase()}/${member?.uuid}`}
                    className={styles.memberName}
                  >
                    {member?.name || member?.full_name}
                  </Link>
                </div>
              ))}
          </div>

          <div className={styles.emailsList}>
            {members &&
              members.map((member, index) => (
                <div key={member.uuid || index} className={styles.emailItem}>
                  {member.email}
                </div>
              ))}
          </div>
        </div>

        <div className={styles.commentSection}>
          <input
            type="text"
            className={styles.commentInput}
            placeholder="Type your message here..."
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handlePostComment()
              }
            }}
          />
          <button className={styles.postButton} onClick={handlePostComment}>
            Post comment
          </button>
        </div>
      </div>
    </div>
  )
}

PeerCircleMembersModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  question: PropTypes.object,
  members: PropTypes.array,
}

export default PeerCircleMembersModal

